import type { ReactNode } from 'react';
import type { DmMessagePatientRow } from '../../../../services/dmMessagesInbox';
import { PriorityPicker } from '../../../work-queue/priority/PriorityPicker';
import { AiMarkedControl } from './AiSetMarker';
import { FrustrationPicker } from './FrustrationPicker';
import { useTriageSetters } from './useTriageSetters';

interface TriageCellProps {
    row: DmMessagePatientRow;
    // Opens the menu upwards for rows near the bottom of the clipped scroll body.
    dropUp: boolean;
}

// Shrinks to the button inside a centred cell, so the menu still anchors to the button.
function CenteredCellControl({ children }: { children: ReactNode }) {
    return <div className="inline-block text-left align-middle">{children}</div>;
}

// Components, not render callbacks: DataTable calls `render` as a plain function, and these need hooks.
export function UrgencyCell({ row, dropUp }: TriageCellProps) {
    const { setUrgency } = useTriageSetters(row.patientId, row.triage);
    return (
        <CenteredCellControl>
            <AiMarkedControl byAi={row.triage.urgencyByAi} reserveSpace>
                <PriorityPicker
                    heading="Priority"
                    requireExtremeReason={false}
                    value={row.triage.urgency}
                    onSelect={setUrgency}
                    dropUp={dropUp}
                    ariaLabel={`Priority for ${row.patientName}`}
                />
            </AiMarkedControl>
        </CenteredCellControl>
    );
}

export function FrustrationCell({ row, dropUp }: TriageCellProps) {
    const { setFrustration } = useTriageSetters(row.patientId, row.triage);
    return (
        <CenteredCellControl>
            <AiMarkedControl byAi={row.triage.frustrationByAi} reserveSpace>
                <FrustrationPicker
                    value={row.triage.frustration}
                    onSelect={setFrustration}
                    dropUp={dropUp}
                    ariaLabel={`Frustration for ${row.patientName}`}
                />
            </AiMarkedControl>
        </CenteredCellControl>
    );
}
